import React, { Component } from 'react';
import SceButton from "../../../../Common/CommonComponents/sceButton";
import ServiceAccountDetailsComponent from './serviceAccountDetailsComponent';
//import ServiceMultiAccountDetailsComponent from './serviceMultiAccountDetailsComponent';
import overlayClasses from "./sceOverlayStyle.scss";
import CheckBox from "../../../../Common/CommonComponents/SceCheckBox";
import classes from './PaperlessBillingTurnonPopup.scss';
import SceTextBox from "../../../../Common/TextBox/sceText";
import { getLocalizedStrings } from "./paperlessBillingPopupLocalisedstrings";
//import TermsCondition from "../../../../BillingAndPayment/Payment/Common/termsCondition";
import TermsCondition from "./PbTermsCondition";
import ConfirmationPopup from "./ConfirmationPopup";
//import Checkbox from "./SceCheckBox";
import Checkbox from "./PbCheckbox";
import PbBulkEnrollmentPopup from "./PbBulkEnrollmentPopup";
import PbErrCard from "./pbErrCard";
import PbEnContentView  from "./PbEnContentView";
import FocusTrap from "focus-trap-react";
import SceErrorBox from '../../../../Common/ErrorBox/sceErrorBox';

export default class PaperlessBillingTurnonPopup extends React.Component {

    constructor(props) {
        super(props);
        this.strings = getLocalizedStrings("PbTurnOnPopup");
        this.state = {

            addEmail: false,unSelectedAccounts: new Map(),
            confPopup: false,
            isCheckboxClicked:false,
            bulkEnroll: false,
            data: this.props.data,
            accountCount:0,
            // clickCaptured :false,
            showCheckboxError: false,

        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        // this.myRefError = React.createRef();
        // this.documentClick=this.documentClick.bind(this);
        let maskedemail;
        this.maskedemail = this.props.primaryEmail.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + '****' + c);
        
            
        let emailIcon;
        let closeIcon;


        let warningIcon;
        this.emailIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOn.svg';
        this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';

        this.warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';


    }
    componentDidMount() {
       
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    componentDidUpdate() {
        if (this.props.pbEnrollErrMsg && document.getElementById("pfcscroll"))  document.getElementById("pfcscroll").scroll(0,0);
    }    
    setWrapperRef(node) {
        this.wrapperRef = node;
    }
    
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && !this.state.bulkEnroll) {
       this.props.isOpen();
    
        }
     } 

    addEmailHandler() {
        this.setState({ addEmail: true });
    }
    openConfirmationPopup() {
        //this.props.submitClick(this.state.data);
        this.setState({ confPopup: this.props.isPbEnrollConfirm });

    }

    bulkEnroll() {
        this.setState({ bulkEnroll: true });
        window.scrollTo(0,0);
    }
    cancelButtonHandlerBulkEnroll() {
        this.setState({ bulkEnroll: false }, () => { });

    }

    handleCallback(childData,unselectedAccounts,selectAllFlag,contractAccountCount) {
        this.setState({ data: childData,unselectedAccounts:unselectedAccounts ,selectAllFlag:selectAllFlag,contractAccountCount:contractAccountCount});
        this.AccountCount(childData,unselectedAccounts,selectAllFlag,contractAccountCount);
        this.setState({ bulkEnroll: true });
        this.props.containerCallback(childData,unselectedAccounts,selectAllFlag,contractAccountCount);    
    }

    handleTermsCallback(checkedStatus){ 
        this.setState({isCheckboxClicked:checkedStatus, showCheckboxError: false });
    }

    handleDisabledBtnClick() {
            this.setState({showCheckboxError: true}, () => {
               document.getElementById("pfcscroll").scroll(0,5000); 
        });
    }

    AccountCount(childData,unselectedAccounts,selectAllFlag,contractAccountCount){
        if(selectAllFlag){
            if(unselectedAccounts.length>0){
                this.setState({accountCount:contractAccountCount-unselectedAccounts.length});

            }
            else{
                this.setState({accountCount:contractAccountCount});
            }
        }
    }
    render() {
       
        let serviceAccountDetailsJSX; 
        serviceAccountDetailsJSX = <ServiceAccountDetailsComponent accountData={this.props.accountData} />; 
        const addAccountJSX =<a href="javascript::void(0)" className={classes.sceSmLink} id={"addAccs"} onClick={this.bulkEnroll.bind(this)}>{this.strings.addAccounts} &nbsp;<i className='fas fa-chevron-right' /></a>;
        let PbEnrollErrorMsg = this.props.pbEnrollErrMsg ? <div className={classes.errEnrollMsg}>{this.props.pbEnrollErrMsg}</div> :null;
        let showErrorCard = this.props.isPbEnrollConfirm === false ?<div><PbErrCard onFormhandler={this.props.submitClick} /></div>: null;

        return (
            <FocusTrap 
            focusTrapOptions={{
               allowOutsideClick: true,
           }}
           >
                {this.state.bulkEnroll ?
                    <PbBulkEnrollmentPopup multiAccountData={this.props.multiAccountData} accountData={this.props.accountData} parentCallback={this.handleCallback.bind(this)} contractAccountResults={this.props.contractAccountResults} isOpen={this.cancelButtonHandlerBulkEnroll.bind(this)} handlePageChange={this.props.handlePageChange} currentPage={this.props.currentPage} contractAccountCount={this.props.contractAccountCount} selectedAcct={this.state.data} unSelectedAccounts={this.state.unSelectedAccounts} selectAllFlow={this.state.selectAllFlag}
                    pageChangeFlag={this.props.pageChangeFlag} cpcPageNumber={this.props.cpcPageNumber} bpNumber={this.props.bpNumber} /> :      
                <div>
                <div tabIndex="0" className={[overlayClasses.sceOverlay, classes.sceSetNotificationsDialog].join(' ')}>
                    <div className={overlayClasses.sceOverlayContent}>
                        <div ref={this.setWrapperRef} className={overlayClasses.sceDialogBox}>
                        <div className='row'>
                            <div className={'col-xs-12 ' + classes.sceSetNotificationMainHeader}>{this.strings.TurnOnPopupTitle}<button className={classes.iconClose} onClick={this.props.isOpen}> <img  src={this.closeIcon} alt="Close Icon" /></button></div>
                        </div>
                           {(this.props.accType === "Single") ?
                                <div>
                                    <div id="pfcscroll" className={classes.scrollContent}>
                                    {PbEnrollErrorMsg}
                                    {showErrorCard}
                                    <span className={classes.sceSetNotificationHeader}>{this.strings.Account}</span>
                                    {/* <div className='row'>
                                        <div className={'col-xs-12 ' + classes.sceSetNotificationHeader}>{this.strings.Account}</div>
                                    </div> */}
                                    <div className={classes.accountHeader}>{serviceAccountDetailsJSX}</div>

                                    <div className={classes.emailNotification}>

                                        <div className={classes.notificationLabel}>
                                            <img className={classes.labelImages} src={this.emailIcon} alt="Email Icon" />
                                            {this.strings.Email}
                                        </div>
                                        <div className={classes.dividerLine} />
                                        <span className={classes.primaryEmail}>{this.maskedemail}</span>
                                        <span className={classes.displayEmailText}>{this.strings.displayText}</span>
                                        <div className={classes.dividerLine} />
                                    </div>

                                    <div className={classes.termsData}>
                                        <TermsCondition contentType={'PAPERLESS_BILLING_TNC'} handleTermsCallback={this.handleTermsCallback.bind(this)} showCheckboxError={this.state.showCheckboxError} />
                                        <SceErrorBox errorMessage={this.strings.tncError} isError={this.state.showCheckboxError} />
                                    </div></div>
                                    <div className="text-align-center sce-space-s">

                                        <div className={classes.footerButton}>
                                            <div className={classes.turnOnBtn}>
                                                {(this.state.isCheckboxClicked) ?
                                                    <SceButton
                                                    id="paperlessBillingTurnOn"
                                                        iconType="rightArrow"
                                                        buttonType="primary"
                                                        value={this.strings.TurnOnButtonValue}
                                                        onClick={this.props.submitClick}

                                                    />
                                                    :
                                                    <SceButton
                                                    id="paperlessBillingTurnOn"
                                                        iconType="rightArrow"
                                                        // isDisabled={!this.state.isCheckboxClicked}
                                                        buttonType="sceDisabled"
                                                        value={this.strings.TurnOnButtonValue}
                                                        onClick={this.handleDisabledBtnClick.bind(this)}
                                                        // onClick={this.props.submitClick}
                                                    />

                                                }

                                            </div>
                                            <div className={classes.cancelBtn}>
                                                <SceButton
                                                    id="paperlessBillingCancel"
                                                    iconType="cancel"
                                                    buttonType="sceCancel"
                                                    value={this.strings.CancelButtonValue}
                                                    onClick={this.props.isOpen}
                                                />
                                            </div> </div> </div> </div>
                                :
                                <div>
                                    <div id="pfcscroll" className={classes.scrollContent}>
                                    {PbEnrollErrorMsg}
                                    {showErrorCard}
                                    <div className={classes.addMoreAcctsSection}>
                                        <div className={'text-right '+classes.addAcct}>{addAccountJSX}</div>                                                                               
                                        <div className={'sce-space-md'}>{this.strings.Account}</div>
                                    </div>
                                    {this.state.data && this.state.data.length>1 ? 
                                            this.state.selectAllFlag?
                                            <div className={classes.header}>{this.state.accountCount} {"Accounts"}</div>:
                                            <div className={classes.header}>{this.state.data.length} {"Accounts"}</div>
                                         :
                                        <div>{serviceAccountDetailsJSX}</div>
                                    }
                                    <div className={classes.emailNotification}>
                                        <div className={classes.notificationLabel}>
                                            <img className={classes.labelImages} src={this.emailIcon} alt="Email Icon" />
                                            {this.strings.Email}
                                        </div>
                                        <div className={classes.dividerLine} />
                                        <span className={classes.primaryEmail}>{this.maskedemail}</span>
                                        <span className={classes.displayEmailText}>{this.strings.displayText}</span>
                                        <div className={classes.dividerLine} />
                                    </div>
                                    <div className={classes.termsData}>
                                        <TermsCondition contentType={'PAPERLESS_BILLING_TNC'} handleTermsCallback={this.handleTermsCallback.bind(this)} isCheckboxClicked={this.state.isCheckboxClicked} showCheckboxError={this.state.showCheckboxError} />
                                        <SceErrorBox errorMessage={this.strings.tncError} isError={this.state.showCheckboxError} />
                                      </div> </div>

                                    <div className="text-align-center">
                                        <div className={classes.footerButton}>
                                        <span>{this.strings.pbBulkNote}</span>
                                            <div className={'sce-space-md ' +classes.turnOnBtn}>
                                                {(this.state.isCheckboxClicked) ?
                                                    <SceButton
                                                    id="paperlessBillingTurnOn"
                                                        iconType="rightArrow"
                                                        buttonType="primary"
                                                        value={this.strings.TurnOnButtonValue}
                                                        onClick={this.props.submitClick}

                                                    />
                                                    : <SceButton
                                                    id="paperlessBillingTurnOn"
                                                        iconType="rightArrow"
                                                        buttonType="sceDisabled"
                                                        value={this.strings.TurnOnButtonValue}
                                                        // isDisabled={!this.state.isCheckboxClicked}
                                                        onClick={this.handleDisabledBtnClick.bind(this)}
                                                        // onClick={this.props.submitClick}
                                                    />

                                                }


                                            </div>
                                            <div className={classes.cancelBtn}>
                                                <SceButton
                                                  id="paperlessBillingCancel"
                                                    iconType="cancel"
                                                    buttonType="sceCancel"
                                                    value={this.strings.CancelButtonValue}
                                                    onClick={this.props.isOpen}
                                                />
                                            </div> </div> </div> </div>
                            }
                        </div>


                    </div>
                </div>               
            </div>}
            </FocusTrap>


        );
    }
}
